/*
 * touch-aware.js -- no-op dotykove posluchace na `document` (1.27.13,
 * PRULOM MAJITELE 14. 9. 00:10, staging 215347/215615, Chrome iOS):
 * "kdyz je zapnuty debug mod, staci 1x tap i kdyz je tam spodni lista;
 * kdyz to neni debug, je 2x tap."
 *
 * Jediny rozdil mezi `?tapdebug=1` a bez nej je, ze logger (`tapdebug.js`)
 * registruje capture/passive posluchace `touchstart`/`touchmove`/
 * `touchend`/`touchcancel`/`pointerdown`/`pointercancel` na `document`.
 * To je znamy WebKit efekt (klasicky trik `<body ontouchstart="">`):
 * pritomnost `touchstart` posluchace na dokumentu prepne zpracovani tapu
 * -- WebKit dokument bere jako "touch-aware" a `click` doruci napoprve,
 * misto aby prvni tap utratil za hover fazi (mouseover/mousemove) a klik
 * odlozil na druhy. Reserse to mela jako "nedolozeno", majitelovy trace
 * (tap #2/#4 s loggerem: touchstart -> touchend ~100-130 ms -> mouseover
 * -> click -> navigace) to dolozily.
 *
 * TENHLE MODUL NIC NEDELA, jen ty posluchace registruje (stejna sada,
 * stejne parametry jako logger, handler prazdny). Musi bezet PRVNI
 * (`index.js`) a NIKDY se nesmi odstranit -- brana `webkit-tap-gate.mjs`
 * kontroluje marker `data-th-touch-aware` na `<html>`.
 *
 * `passive: true`: prohlizec nemusi cekat na handler, scroll zustava
 * plynuly. `capture: true`: stejne jako logger, aby se replikovalo presne
 * to, co majitel otestoval.
 */

/** Marker pro branu: `<html data-th-touch-aware="1">`. */
const MARKER = 'data-th-touch-aware';

/** Udalosti, ktere logger registruje na `document` (viz `tapdebug.js`). */
const EVENTS = ['touchstart', 'touchmove', 'touchend', 'touchcancel', 'pointerdown', 'pointercancel'];

/**
 * @return {void}
 */
function noop() {
	// Zamerne prazdne -- rozhoduje pritomnost posluchace, ne jeho obsah.
}

/**
 * Inicializace: registruje no-op posluchace a nastavi marker.
 *
 * @return {void}
 */
export function init() {
	if (typeof document === 'undefined') {
		return;
	}

	EVENTS.forEach(function (type) {
		document.addEventListener(type, noop, { capture: true, passive: true });
	});

	document.documentElement.setAttribute(MARKER, '1');
}
